let lenisInstance = null;

export const setLenis = (lenis) => {
  lenisInstance = lenis;
};

export const scrollToSection = (target) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const requestLeadType = (type) => {
  window.dispatchEvent(new CustomEvent("seraph:lead-type", { detail: type }));
};
